import styled from "styled-components";

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1050;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	background-color: rgba(0, 0, 0, 0.45);
`;

export const Card = styled.div`
	position: relative;
	width: 550px;
	max-width: 100%;
	background: #ffffff;
	border-radius: 8px;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
	padding: 40px 40px 32px;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 14px;
	right: 14px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: transparent;
	border: 0;
	cursor: pointer;
	outline: 0;
	padding: 4px;
	line-height: 0;
	&:focus-visible {
		outline: 2px solid var(--secondary-border-color);
		outline-offset: 2px;
	}
`;

export const Title = styled.h2`
	margin: 0 0 12px;
	font: normal normal bold 20px/26px Lato;
	color: var(--third-color);
	text-align: center;
`;

export const Message = styled.p`
	margin: 0 0 28px;
	font: normal normal normal 14px/22px Lato;
	color: var(--third-color);
	text-align: center;
`;

export const Actions = styled.div`
	display: flex;
	justify-content: center;
	gap: 12px;
	flex-wrap: wrap;

	@media (max-width: 420px) {
		flex-direction: column-reverse;
	}
`;
